import React, { useMemo, useRef } from 'react';
import { CSVLink } from 'react-csv';
import { Box, ButtonV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import type { InternalMessage } from '../../MessagesV2.types';
import { buildCsvRows, CSV_HEADERS } from './messagesCsv.utils';

type MessagesV2TableActionsProps = Readonly<{
  filteredMessages: InternalMessage[];
  /**
   * Numbered by the caller over the whole page, so the export and the table can never disagree and
   * a post-filter cannot depress the number of a row it left alone.
   */
  attemptNumberById: ReadonlyMap<string, number>;
  loading: boolean;
}>;

export const MessagesV2TableActions: React.FC<MessagesV2TableActionsProps> = ({ filteredMessages, attemptNumberById, loading }) => {
  const { tq } = useTranslation('messagesV2ServiceCenter');
  const downloadRef = useRef<CSVLink & HTMLAnchorElement & { link: HTMLAnchorElement }>(null);

  const csvData = useMemo(() => buildCsvRows(filteredMessages, attemptNumberById), [filteredMessages, attemptNumberById]);

  if (filteredMessages.length === 0) {
    return null;
  }

  return (
    <Box
      display="flex"
      justifyContent="flex-end"
    >
      <CSVLink
        data={csvData}
        filename="MessagesV2.csv"
        headers={CSV_HEADERS}
        ref={downloadRef}
      />
      <ButtonV2
        type="button"
        variant="ghost"
        disabled={loading}
        onClick={() => downloadRef.current?.link.click()}
      >
        {tq`Export CSV`}
      </ButtonV2>
    </Box>
  );
};
